import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Scenarios from './Scenarios';

const ScenariosPicker = (props) => {
  const { pageContentResource } = usePageContentContext();

  if (pageContentResource.attr('scenarios')) {
    return <Scenarios {...props} />;
  }

  return null;
};

export default ScenariosPicker;
